import { createWebHistory, createRouter } from "vue-router";
import VisitanteSection from "@/components/VisitanteSection.vue";
import StaffSection from "@/components/StaffSection.vue";
import AcreditacionFinalizada from "@/components/AcreditacionFinalizada.vue";
import NotFoundSection from "@/components/NotFoundSection.vue";
import CredencialSection from "@/components/CredencialSection.vue";
import PrensaSection from "@/components/PrensaSection.vue";
import DisertanteSection from "@/components/DisertanteSection.vue";
import EquiposComunicacionSection from "@/components/EquiposComunicacionSection.vue";
import HomeSection from "@/components/HomeSection.vue";

const routes = [
  {
    path: "/",
    component: HomeSection,
  },
  {
    path: "/staff",
    component: StaffSection,
  },
  {
    path: "/prensa",
    component: PrensaSection,
  },
  {
    path: "/comunicacion",
    component: EquiposComunicacionSection,
  },
  {
    path: "/disertante",
    component: DisertanteSection,
  },
  {
    path: "/credenciales",
    component: CredencialSection,
  },
  {
    path: "/finalizado",
    component: AcreditacionFinalizada,
  },
  {
    path: "/:catchAll(.*)",
    component: NotFoundSection,
  },  
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: routes,
  scrollBehavior() {
    return { top: 0 }
  }
});

export default router;